// NetworkStatus — small pill shown in topbars.
//   • Hidden when online with no pending items
//   • Shows offline indicator when navigator.onLine === false
//   • Shows pending-sync count when there are queued mutations

import type { ReactElement } from 'react';
import { useOffline } from './context.js';

export function NetworkStatus(): ReactElement | null {
  const { online, pending, syncing, drain } = useOffline();

  if (online && pending === 0) return null;

  if (!online) {
    return (
      <span className="text-[11px] px-2 py-0.5 rounded-full bg-warn-soft text-warn font-medium">
        Offline{pending > 0 ? ` · ${pending} queued` : ''}
      </span>
    );
  }

  // Online but with pending items → encourage manual sync
  return (
    <button
      type="button"
      onClick={() => void drain()}
      disabled={syncing}
      className="text-[11px] px-2 py-0.5 rounded-full bg-info-soft text-info font-medium hover:bg-info hover:text-white disabled:opacity-50"
    >
      {syncing ? 'Syncing…' : `Sync ${pending} pending`}
    </button>
  );
}
